import Checkbox from "@mui/material/Checkbox";
import React from "react";

function UncheckedIcon({iconSize = 30}) {
    return <svg className='checkbox-theme-unchecked' xmlns="http://www.w3.org/2000/svg" width={iconSize} height={iconSize} viewBox={`0 0 30 30`}>
        <rect x="1" y="1" width="28" height="28" rx="9" strokeWidth="2"/>
    </svg>;
}

function CheckedIcon({iconSize = 30}) {
    return <svg className='checkbox-theme-checked' xmlns="http://www.w3.org/2000/svg" width={iconSize} height={iconSize} viewBox={`0 0 30 30`}>
        <rect x="1" y="1" width="28" height="28" rx="9" strokeWidth="2"/>
        <line x1="9.96967" y1="21.9697" x2="24.9697" y2="6.96967" strokeWidth="1.5"/>
        <line x1="5.03033" y1="15.9697" x2="11.0303" y2="21.9697" strokeWidth="1.5"/>
    </svg>;
}
export function FrontlineCheckbox({isChecked, onChange, onClick, size = 48, isWithPadding=true}) {
    const iconSize = isWithPadding ? size * 0.625: size;
    const sx = isWithPadding ? {} :{
        padding: 0,
            width: size,
            height: size,
            "& .MuiSvgIcon-root": {
            width: size,
                height: size
        }
    }
    return <Checkbox
        className='frontline-checkbox'
        checkedIcon={<CheckedIcon iconSize={iconSize}/>}
        icon={<UncheckedIcon iconSize={iconSize}/>}
        checked={isChecked}
        onClick={(e)=>{if (onClick) onClick(e)}}
        onChange={e => {onChange(e.target.checked)}}
        sx={sx}
        style={{ width: size, height: size }}
    />;
}
